import {menuTypes} from '../constanst/index';

const initialState={
    menu:{
        showDrawer:false, 
        fullScreen:false
    },
    menuItemSelected:'0',
}

const menuReducer = (state=initialState, action:any) =>{
    switch(action.type){
        case menuTypes.MENU_SHOWDRAWER:
            return{
                ...state,
                menu:{...state.menu, showDrawer:true}
            }
        case menuTypes.MENU_CLOSEDRAWER:
            return{
                ...state,
                menu:{...state.menu, showDrawer:false}
            }
        case menuTypes.MENU_ITEM_SELECTED:
            return{
                ...state,
                menuItemSelected:action.payload
            }
            case menuTypes.MENU_FULLSCREAN:
                return{
                    ...state,
                    menu:{...state.menu, fullScreen:action.payload}
                }
        default:
            return state;
    }
}

export default menuReducer;